import LogoIcon from 'public/icons/logo.svg'

const Logo = () => {
    return <LogoIcon />
}

export default Logo
